import { getLocale } from '../../types'
import { i18n } from '../config'
import { LOCALE_KEY } from '../consts'
import { TLocales } from '../locales/types'

const setLocale = (locale: TLocales) => {
   localStorage.setItem(LOCALE_KEY, locale)
   i18n.changeLanguage(locale)
}

const useLocalization = () => {
   return [getLocale(), setLocale] as const
}

export default useLocalization
